import React__default from 'react';
import { Modal, ModalFooter } from '@grandvisionhq/common';
import { CheckboxWithLabel, Util } from '@grandvisionhq/forms';
import { useDispatch, useSelector } from '@grandvisionhq/state';
import { useFormSlot } from '../../slots/forms/form-context.js';
import { useBaseSummarySlot } from '../../slots/summaries/summary-context.js';
import { updateShippingDetails, toggleDeliveryAddress } from '../../StepShipping/actions.js';
import { getShippingData, getSelectedShippingMethod } from '../../StepShipping/selectors.js';
import { TitleWithIcon } from '../../components/TitleWithIcon/TitleWithIcon.js';
import { isDelivery, isDeliveryExpress } from '../../utils/shipping-method.js';

const hasAddressData = (addressData)=>Boolean(addressData && !Object.values(addressData).every((x)=>x === null || x === ''
    ))
;
const EditableAddressesSummary = ({ labels  })=>{
    var ref, ref1, ref2, ref3;
    const [billingAddressFormData, setBillingAddressFormData] = React__default.useState();
    const [deliveryAddressFormData, setDeliveryAddressFormData] = React__default.useState();
    const { billingAddress: billingAddressForm , deliveryAddress: deliveryAddressForm  } = useFormSlot({
        onChange: (formData)=>{
            if (formData.formName === 'billingAddress') {
                setBillingAddressFormData(formData);
            }
            if (formData.formName === 'deliveryAddress') {
                setDeliveryAddressFormData(formData);
            }
        }
    });
    const [isModalOpen, setIsModalOpen] = React__default.useState(false);
    const { Slots  } = useBaseSummarySlot();
    const dispatch = useDispatch();
    const billingAddressData = (ref = useSelector(getShippingData)) === null || ref === void 0 ? void 0 : ref.billingAddress;
    const deliveryAddressData = (ref1 = useSelector(getShippingData)) === null || ref1 === void 0 ? void 0 : ref1.deliveryAddress;
    const selectedShippingMethod = (ref2 = useSelector(getSelectedShippingMethod)) === null || ref2 === void 0 ? void 0 : ref2.method;
    const isDelivery$1 = isDelivery(selectedShippingMethod);
    const isDeliveryExpress$1 = isDeliveryExpress(selectedShippingMethod);
    const [addressesAreEqual, setAddressesAreEqual] = React__default.useState(!Boolean(deliveryAddressData));
    React__default.useEffect(()=>{
        setAddressesAreEqual(!Boolean(deliveryAddressData));
    }, [
        deliveryAddressData
    ]);
    const hasBillingAddressData = hasAddressData(billingAddressData);
    const hasDeliveryAddressData = hasAddressData(deliveryAddressData);
    const hasData = hasBillingAddressData || hasDeliveryAddressData;
    const AddressesSummarySlot = Slots.addresses;
    let isPickupOrder = false;
    if (!isDelivery$1 && !isDeliveryExpress$1) {
        isPickupOrder = true;
    }
    if (!AddressesSummarySlot && hasData) {
        console.error('This opco is misconfigured. It has addresses data, but no addresses summary card setup.');
    }
    if (!AddressesSummarySlot || !hasData) {
        return null;
    }
    const handleSubmit = ()=>{
        if (!(billingAddressFormData === null || billingAddressFormData === void 0 ? void 0 : billingAddressFormData.formValid) || !addressesAreEqual && !(deliveryAddressFormData === null || deliveryAddressFormData === void 0 ? void 0 : deliveryAddressFormData.formValid)) {
            Util.focusToTopErrorFieldOnScreen();
        } else {
            billingAddressFormData && dispatch(updateShippingDetails({
                form: billingAddressFormData
            }));
            deliveryAddressFormData && dispatch(updateShippingDetails({
                form: deliveryAddressFormData
            }));
            dispatch(toggleDeliveryAddress({
                enabled: !addressesAreEqual
            }));
            setIsModalOpen(false);
        }
    };
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Modal, {
        isOpen: isModalOpen,
        onModalClose: ()=>setIsModalOpen(false)
        ,
        showIcon: true,
        footer: /*#__PURE__*/ React__default.createElement(ModalFooter, {
            ctaCaption: labels === null || labels === void 0 ? void 0 : (ref3 = labels.editModal) === null || ref3 === void 0 ? void 0 : ref3.save,
            onCta: handleSubmit,
            onCancel: ()=>setIsModalOpen(false)
        })
    }, /*#__PURE__*/ React__default.createElement(TitleWithIcon, {
        icon: "billing",
        label: labels.generic.title
    }), billingAddressForm, !isPickupOrder && /*#__PURE__*/ React__default.createElement(CheckboxWithLabel, {
        id: "usingDeliveryAddress",
        value: "usingDeliveryAddress",
        checked: addressesAreEqual,
        onChange: ()=>{
            setAddressesAreEqual(!addressesAreEqual);
        },
        className: "billing-and-delivery-form__checkbox",
        label: labels === null || labels === void 0 ? void 0 : labels.differentDeliveryAddress
    }), !addressesAreEqual && !isPickupOrder && deliveryAddressForm), hasData && /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(AddressesSummarySlot, {
        actions: {
            onEdit: ()=>setIsModalOpen(true)
        },
        values: {
            isAddressesEqual: !hasDeliveryAddressData,
            isPickupOrder,
            billingAddress: billingAddressData,
            deliveryAddress: deliveryAddressData
        }
    })));
};

export { EditableAddressesSummary, EditableAddressesSummary as default };
//# sourceMappingURL=EditableAddressesSummary.js.map
